import script from "./ExibitionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExibitionCard.vue?vue&type=script&lang=ts&setup=true"

import "./ExibitionCard.vue?vue&type=style&index=0&id=bb01f52a&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb01f52a"]])

export default __exports__